const state = {
  allIds: [],
  byId: {}
};

const getters = {
  find: (state, _, rootState) => id => {
    if (!state.byId?.[id]) return;
    return {
      ...state.byId[id],
      package: rootState.packages.byId[state.byId[id].package_id]
    };
  },
  list: (state, getters) => state.allIds.map(id => getters.find(id))
};

const actions = {
  addOrderPackages: ({ commit }, orderPackages) => {
    orderPackages.forEach(op => {
      op.package = [op.package_id];
      op.type = 'package';
      commit('add', op);
    });
  }
};

const mutations = {
  add: (state, orderPackage) => {
    state.byId[orderPackage.id] = orderPackage;
    if (state.allIds.includes(orderPackage.id)) return;
    state.allIds.push(orderPackage.id);
  }
};

export default {
  namespaced: true,
  getters,
  state,
  actions,
  mutations
};
